import createSubtitleFabric from "../../../general/CoreHeader/components/Subtitle/subtitleFabric";
import { createDisplayNameForHeaderShowAll } from "../../utils/createDisplayName";
import { createTestIdForHeaderShowAll } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderShowAll("Subtitle");
const testId = createTestIdForHeaderShowAll("subtitle");

const HeaderShowAllSubtitle = createSubtitleFabric(displayName, testId);

export default HeaderShowAllSubtitle;
